import { useQuery } from "@tanstack/react-query";
import { usersApi } from "../api";
import { queryClient } from "../providers/QueryProvider";

export const useGetUsers = () => {
  return useQuery({
    queryKey: ["users"],
    queryFn: () => usersApi.getUsers(),
    staleTime: 5 * 60 * 1000,
  });
};

export const useGetJeopardyStakeholders = ({ params }: { params?: { project_id?: string | number, programme_id?: string | number, portfolio_id?: string | number } }) => {

  const { data, isLoading, refetch } = useQuery({
    queryKey: ["stakeholders", params],
    queryFn: () => usersApi.getJeopardyStakeholders({ params }),
   
  });

  return {
    data, isLoading, refetch,
    removeCache: () => { queryClient.removeQueries({ queryKey: ["stakeholders", params] }); }
  };

};